import { render, staticRenderFns } from "./ruleConfiguration.vue?vue&type=template&id=23920d86"
import script from "./ruleConfiguration.vue?vue&type=script&lang=js"
export * from "./ruleConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports